export default "__VITE_ASSET__ab278848__"